import Music from './Music'

export default Music
